import React, { useState } from "react";
import TeaLogo from "../../assets/tea-logoVersion.svg"
import { ChakraProvider, Box, Center, CSSReset, Heading, Text, Collapse, useToast } from '@chakra-ui/react';
import CustomInput from "../../components/Input";
import Button from "../../components/Button";
import { Flex } from "@chakra-ui/react"
import CustomButton from "../../components/Button";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function ForgetPassword() {
    const navigate = useNavigate();
    // State para manejar el estado actual del proceso de recuperación de contraseña
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const toast = useToast();
    // Función para manejar el clic en el botón de continuar
    const handleContinue = async () => {
        if (step === 1) {
            try {
                const response = await axios.post(
                    `https://teaapitest.azurewebsites.net/User/forgot-password?email=${encodeURIComponent(email)}`
                );
                if (response.status === 200) {
                    // Mostrar un Toast de éxito cuando se envíe el correo electrónico
                    toast({
                        title: "Email Sent",
                        description: "Mail sent successfully. Check your inbox for further instructions.",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });
                    setStep(2);
                } else {
                    // Manejar una solicitud no exitosa
                    toast({
                        title: "Error",
                        description: response.data.message,
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.error("Error:", error);
                // Mostrar un Toast si hay un error
                toast({
                    title: "Error",
                    description: "There was an error sending the email",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        } else if (step === 2) {
            if (password !== confirmPassword) {
                // Mostrar un Toast si las contraseñas no coinciden
                toast({
                    title: "Error",
                    description: "Passwords do not match. Please try again.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                return;
            }
            try {
                const resetPasswordData = {
                    correo : email,
                    codigo: otp,
                    password: password,
                    confirmPassword: confirmPassword
                };
                const response = await axios.post(
                    `https://teaapitest.azurewebsites.net/User/reset-password`,
                    resetPasswordData
                );
                if (response.data.success) {
                    // Redireccionar a la página de inicio de sesión si el restablecimiento de contraseña fue exitoso
                    navigate("/Login") 
                    // Mostrar un Toast de éxito cuando se restablezca la contraseña
                    toast({
                        title: "Password Reset",
                        description: "Password reset successfully. You can now login with your new password.",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });
                } else {
                    // Manejar una solicitud no exitosa
                    toast({
                        title: "Error",
                        description: response.data.message,
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.error("Error:", error);
                // Mostrar un Toast si hay un error
                toast({
                    title: "Error",
                    description: "There was an error resetting the password. Please try again.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        }
    };

    return (
        <div>
            <ChakraProvider>
                <CSSReset />

                <Flex
                    as="nav"
                    align="center"
                    justify="end"
                    padding="1rem"
                    position="fixed"
                    top="0"
                    left="0"
                    right="0"
                    zIndex="999"
                    background="transparent" // Cambiado a transparente para que se mezcle naturalmente con la página
                    width="100%"
                    borderBottomWidth="0" // Eliminando la línea divisoria que parece naturalmente de la página
                >
                    <CustomButton
                        textColor="#85BEB5"
                        text="Log In"
                        width="149px"
                        height="50px"
                        boxShadowColor="#FFFFFF"
                        borderColor="#AEECE2"
                        borderWidth="2px"
                        backgroundColor="#FFFFFF"
                        stroke="2px solid #AEECE2"
                        to="/login"
                    />
                </Flex>

                <Center height="100vh" flexDirection="column">
                    <Box position="absolute" top="70px">
                        <Center>
                            <img src={TeaLogo} alt="" />
                        </Center>
                    </Box>

                    <Collapse in={step === 1} >
                        <Center flexDirection="column" maxWidth="500px">
                            <Box mb="30px">
                                <Heading
                                    as="h2"
                                    size="xl"
                                    color="#3C3C3C"
                                    textAlign="center"
                                    fontFamily="Inter"
                                    fontSize="23px"
                                    fontStyle="normal"
                                    fontWeight="700"
                                    lineHeight="40px"
                                >
                                    Did you forget your password?
                                </Heading>
                            </Box>

                            <Box mb="30px">
                                <Text
                                    color="#3C3C3C"
                                    textAlign="center"
                                    fontFamily="Inter"
                                    fontSize="17px"
                                    fontStyle="normal"
                                    fontWeight="500"
                                    lineHeight="20px"
                                >
                                    We will send you instructions on how to <br /> reset your password by <br /> email.
                                </Text>
                            </Box>

                            <Box mb="30px">
                                <CustomInput label="Email" type="text" onChange={(e) => setEmail(e.target.value)} />
                            </Box>

                            <Box mb="28px">
                                <Button text="Send" onClick={handleContinue} />
                            </Box>
                        </Center>
                    </Collapse>

                    <Collapse in={step === 2}>
                        <Center flexDirection="column" maxWidth="500px">
                            <Box mb="30px">
                                <Heading
                                    as="h2"
                                    size="xl"
                                    color="#3C3C3C"
                                    textAlign="center"
                                    fontFamily="Inter"
                                    fontSize="23px"
                                    fontStyle="normal"
                                    fontWeight="700"
                                    lineHeight="40px"
                                >
                                    Reset your password
                                </Heading>
                            </Box>

                            <Box mb="30px">
                                <Text
                                    color="#3C3C3C"
                                    textAlign="center"
                                    fontFamily="Inter"
                                    fontSize="17px"
                                    fontStyle="normal"
                                    fontWeight="500"
                                    lineHeight="20px"
                                >
                                    Enter the OTP code and your new password.
                                </Text>
                            </Box>

                            <Box mb="10px">
                                <CustomInput label="Enter your OTP code" type="text" onChange={(e) => setOtp(e.target.value)} />
                            </Box>

                            <Box mb="10px">
                                <CustomInput label="Enter your password" type="password" onChange={(e) => setPassword(e.target.value)} />
                            </Box>

                            <Box mb="30px">
                                <CustomInput label="Confirm your passowrd" type="password" onChange={(e) => setConfirmPassword(e.target.value)} />
                            </Box>

                            <Box mb="28px">
                                <Button text="Send" onClick={handleContinue} />
                            </Box>
                        </Center>
                    </Collapse>

                </Center>
            </ChakraProvider>
        </div>
    )
}

export default ForgetPassword;

